(function () {
  if (window.QLSPolishedCommerceUIV125) return;
  window.QLSPolishedCommerceUIV125 = true;

  var dialog;
  var activeWidget;
  var previousRootOverflow = '';

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function currentWidget(widget) {
    if (widget && widget.isConnected) return widget;
    return document.querySelector('.cart-drawer__summary .simply-insurance.widget, #cart-summary .simply-insurance.widget, .simply-insurance.widget');
  }

  function getToggle(widget) {
    widget = currentWidget(widget);
    if (!widget) return null;
    return widget.querySelector('input.cart-insurance-input[type="checkbox"], input[type="checkbox"], [role="switch"], button[class*="toggle" i]');
  }

  function toggleIsOn(toggle) {
    if (!toggle) return false;
    if (toggle.matches && toggle.matches('input[type="checkbox"]')) return !!toggle.checked;
    return toggle.getAttribute('aria-checked') === 'true' || toggle.classList.contains('active') || toggle.classList.contains('checked');
  }

  function setProtection(widget, shouldEnable) {
    widget = currentWidget(widget);
    if (!widget) return false;

    var input = widget.querySelector('input.cart-insurance-input[type="checkbox"], input[type="checkbox"]');
    if (input) {
      if (!!input.checked === shouldEnable) return true;
      var label = input.id ? widget.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      label = label || widget.querySelector('.switch-button label.switch, label.switch, .switch');
      if (label && typeof label.click === 'function') label.click();
      else input.click();
      return true;
    }

    var toggle = getToggle(widget);
    if (toggle && toggleIsOn(toggle) !== shouldEnable) {
      toggle.click();
      return true;
    }
    return !!toggle;
  }

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('div');
    dialog.className = 'qls-protection-dialog';
    dialog.hidden = true;
    dialog.innerHTML = '' +
      '<div class="qls-protection-dialog__backdrop" data-qls-protection-close></div>' +
      '<section class="qls-protection-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="qls-protection-title" tabindex="-1">' +
        '<button class="qls-protection-dialog__close" type="button" aria-label="Close" data-qls-protection-close>&times;</button>' +
        '<div class="qls-protection-dialog__hero" aria-hidden="true"><div class="qls-protection-dialog__box"></div><div class="qls-protection-dialog__shield">✓</div></div>' +
        '<h2 id="qls-protection-title">Your bottles, protected</h2>' +
        '<p class="qls-protection-dialog__intro">Helps cover loss, damage or theft while your order is in transit.</p>' +
        '<div class="qls-protection-benefits">' +
          '<div class="qls-protection-benefit"><span class="qls-protection-benefit__icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8.5 12 5l7 3.5v7L12 19l-7-3.5v-7Z M12 5v14 M5 8.5l7 3.5 7-3.5"/><path d="M8.2 4.7 12 3l3.8 1.7"/></svg></span><div><strong>Lost</strong><p>Coverage support if your order is lost in transit.</p></div></div>' +
          '<div class="qls-protection-benefit"><span class="qls-protection-benefit__icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8.5 12 5l7 3.5v7L12 19l-7-3.5v-7Z M5 8.5l7 3.5 7-3.5"/><path d="m12 5-1 4 2 2-2 3 1 5"/></svg></span><div><strong>Damaged</strong><p>Help if bottles arrive damaged during shipping.</p></div></div>' +
          '<div class="qls-protection-benefit"><span class="qls-protection-benefit__icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5 19 6v5.4c0 4.2-2.8 7.4-7 9.1-4.2-1.7-7-4.9-7-9.1V6l7-2.5Z"/><path d="M12 8v5 M12 16h.01"/></svg></span><div><strong>Stolen</strong><p>Coverage support if a delivered shipment is stolen.</p></div></div>' +
        '</div>' +
        '<p class="qls-protection-dialog__terms">Claims are subject to the package-protection terms and eligibility requirements.</p>' +
      '</section>';
    document.body.appendChild(dialog);

    dialog.querySelectorAll('[data-qls-protection-close]').forEach(function (el) {
      el.addEventListener('click', closeDialog);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog && !dialog.hidden) closeDialog();
    });
    return dialog;
  }

  function openDialog(widget) {
    activeWidget = widget;
    var el = ensureDialog();
    previousRootOverflow = document.documentElement.style.overflow;
    el.hidden = false;
    document.documentElement.classList.add('qls-protection-dialog-open');
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(function () { el.querySelector('.qls-protection-dialog__panel').focus({ preventScroll: true }); }, 20);
  }

  function closeDialog() {
    if (!dialog) return;
    dialog.hidden = true;
    document.documentElement.classList.remove('qls-protection-dialog-open');
    document.documentElement.style.overflow = previousRootOverflow;
    previousRootOverflow = '';
  }

  function decorateCheckoutProtection(container) {
    if (!container || container.dataset.qlsCheckoutPolished === 'true') return;
    container.dataset.qlsCheckoutPolished = 'true';
    container.classList.add('qls-checkout-protection-polished');

    var label = container.querySelector('.ssp-checkout-text-wrapper');
    var oldInfo = container.querySelector('.btnCstm.tooltipCstm');
    if (oldInfo) oldInfo.style.display = 'none';

    if (label && !label.querySelector('.qls-checkout-protection-details')) {
      var details = document.createElement('button');
      details.type = 'button';
      details.className = 'qls-checkout-protection-details';
      details.textContent = 'More information';
      details.setAttribute('aria-haspopup', 'dialog');
      details.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        activeWidget = container;
        openDialog(container);
      });
      label.appendChild(details);
    }
  }

  function decorateProtection(widget) {
    if (!widget || widget.dataset.qlsPolished === 'true') return;
    widget.dataset.qlsPolished = 'true';
    widget.classList.add('qls-protection-polished');

    var titleWrap = widget.querySelector('.insurance-title-wrap') || widget.querySelector('.title-image-wrap') || widget;
    var description = widget.querySelector('.plan-description');
    if (description) {
      var text = cleanText(description.textContent).toLowerCase();
      if (!text || text.indexOf('loss') === -1) description.textContent = 'Covers loss, damage & theft';
    }

    if (!titleWrap.querySelector('.qls-protection-meta')) {
      var meta = document.createElement('div');
      meta.className = 'qls-protection-meta';
      meta.innerHTML = '<span class="qls-protection-optional">Optional</span><button type="button" class="qls-protection-details">Details</button>';
      titleWrap.appendChild(meta);
      meta.querySelector('.qls-protection-details').addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openDialog(widget);
      });
    }
  }

  function polishKlaviyo(root) {
    (root || document).querySelectorAll('button, a').forEach(function (el) {
      var text = cleanText(el.textContent).toLowerCase();
      if (text === 'notify me when available' || text === 'notify when available' || text === 'notify me') {
        el.classList.add('klaviyo-bis-trigger');
      }
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.simply-insurance.widget').forEach(decorateProtection);
    (root || document).querySelectorAll('.ssp-checkout-button-container').forEach(decorateCheckoutProtection);
    polishKlaviyo(root || document);
  }

  function init() {
    scan(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.simply-insurance.widget')) decorateProtection(node);
          if (node.matches && node.matches('.ssp-checkout-button-container')) decorateCheckoutProtection(node);
          scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('qls:shipping-protection:settled', function () { scan(document); });
    [400, 1000, 2200, 4500].forEach(function (delay) { setTimeout(function () { scan(document); }, delay); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* QLS v133 — synchronize cart/delivery overlay layers and Shopify Inbox. */
(function () {
  if (window.QLSCommerceOverlayLayeringV133) return;
  window.QLSCommerceOverlayLayeringV133 = true;

  var root = document.documentElement;
  var scheduledFrame = 0;
  var klaviyoPopupEventOpen = false;
  var gorgiasSuppressed = false;
  var gorgiasHiddenHosts = new Set();
  var gorgiasOriginalInlineStyles = new WeakMap();
  var mobileOverlayQuery = window.matchMedia('(max-width: 768px)');

  function rememberGorgiasHost(host) {
    if (!host || !host.style || gorgiasHiddenHosts.has(host)) return;
    gorgiasOriginalInlineStyles.set(host, {
      displayValue: host.style.getPropertyValue('display'),
      displayPriority: host.style.getPropertyPriority('display'),
      pointerValue: host.style.getPropertyValue('pointer-events'),
      pointerPriority: host.style.getPropertyPriority('pointer-events')
    });
    gorgiasHiddenHosts.add(host);
  }

  function restoreInlineProperty(host, property, value, priority) {
    if (value) host.style.setProperty(property, value, priority || '');
    else host.style.removeProperty(property);
  }

  function shadowLooksLikeGorgias(host) {
    if (!host || !host.shadowRoot) return false;
    try {
      return Boolean(host.shadowRoot.querySelector(
        '.activator-nudge, button[part="activator"], [data-icon-name="chat-bubble"], #chat-button, #chat-window'
      ));
    } catch (error) {
      return false;
    }
  }

  function discoverGorgiasHosts() {
    var hosts = [];
    var seen = new Set();

    function add(host) {
      if (!host || seen.has(host)) return;
      seen.add(host);
      hosts.push(host);
    }

    document.querySelectorAll([
      '#gorgias-chat-container',
      'gorgias-chat-messenger',
      '[data-gorgias-chat]',
      '[data-gorgias-chat-container]',
      '[id*="gorgias-chat" i]'
    ].join(',')).forEach(add);

    if (!hosts.length) {
      document.querySelectorAll('*').forEach(function (element) {
        if (element.tagName && element.tagName.indexOf('-') !== -1 && shadowLooksLikeGorgias(element)) {
          add(element);
        }
      });
    }

    return hosts;
  }

  function applyGorgiasSuppression(hidden) {
    gorgiasSuppressed = hidden;

    if (hidden) {
      discoverGorgiasHosts().forEach(function (host) {
        rememberGorgiasHost(host);
        host.style.setProperty('display', 'none', 'important');
        host.style.setProperty('pointer-events', 'none', 'important');
      });
      return;
    }

    gorgiasHiddenHosts.forEach(function (host) {
      if (!host || !host.style) return;
      var original = gorgiasOriginalInlineStyles.get(host) || {};
      restoreInlineProperty(host, 'display', original.displayValue, original.displayPriority);
      restoreInlineProperty(host, 'pointer-events', original.pointerValue, original.pointerPriority);
    });
    gorgiasHiddenHosts.clear();
  }

  function reinforceGorgiasSuppression() {
    if (!gorgiasSuppressed) return;
    applyGorgiasSuppression(true);
  }

  function drawerIsOpen(drawer) {
    return Boolean(
      drawer
      && (
        drawer.hasAttribute('open')
        || drawer.getAttribute('aria-hidden') === 'false'
      )
    );
  }

  function elementIsVisible(element) {
    if (!element || !element.isConnected) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function klaviyoPopupIsOpen() {
    if (klaviyoPopupEventOpen) return true;

    var candidates = document.querySelectorAll([
      '[data-testid="POPUP"]',
      '[data-testid="popup"]',
      '[role="dialog"][class*="klaviyo" i]',
      '[role="dialog"][id*="klaviyo" i]'
    ].join(','));

    for (var i = 0; i < candidates.length; i += 1) {
      if (elementIsVisible(candidates[i])) return true;
    }
    return false;
  }

  function synchronizeLayers() {
    scheduledFrame = 0;

    var drawer = document.querySelector('#cart-drawer.drawer--cart, cart-drawer#cart-drawer');
    var cartOpen = drawerIsOpen(drawer);
    var cartPopupOpen = Boolean(
      drawer
      && drawer.querySelector('cart-drawer-disclosure details[open]')
    );
    var headerDeliveryOpen = Boolean(document.querySelector(
      '[data-qls-delivery-menu][open], [data-qls-delivery-desktop][open]'
    ));
    var quickBuyOpen = drawerIsOpen(document.querySelector('quick-add-drawer'));
    var klaviyoPopupOpen = klaviyoPopupIsOpen();
    var mobileMenuOpen = Boolean(
      root.classList.contains('qls-mobile-menu-open')
      || document.querySelector('.main-menu__toggle[aria-controls="main-menu-content"][aria-expanded="true"]')
    );
    var commerceLayerOpen = cartOpen || cartPopupOpen || headerDeliveryOpen;
    var shouldSuppressGorgias = Boolean(
      mobileOverlayQuery.matches
      && (mobileMenuOpen || quickBuyOpen || klaviyoPopupOpen)
    );

    root.classList.toggle('qls-cart-layer-open', cartOpen);
    root.classList.toggle('qls-cart-popup-layer-open', cartPopupOpen);
    root.classList.toggle('qls-header-delivery-layer-open', headerDeliveryOpen);
    root.classList.toggle('qls-quickbuy-layer-open', quickBuyOpen);
    root.classList.toggle('qls-klaviyo-popup-layer-open', klaviyoPopupOpen);
    root.classList.toggle('qls-commerce-layer-open', commerceLayerOpen);

    if (drawer) {
      drawer.classList.toggle('qls-cart-popup-open', cartPopupOpen);
    }

    applyGorgiasSuppression(shouldSuppressGorgias);
    if (shouldSuppressGorgias) {
      setTimeout(reinforceGorgiasSuppression, 80);
      setTimeout(reinforceGorgiasSuppression, 300);
      setTimeout(reinforceGorgiasSuppression, 900);
    }
  }

  function scheduleSynchronization() {
    if (scheduledFrame) return;
    scheduledFrame = window.requestAnimationFrame(synchronizeLayers);
  }

  function initializeOverlayLayering() {
    synchronizeLayers();

    var observer = new MutationObserver(scheduleSynchronization);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden'],
      childList: true,
      subtree: true
    });

    document.addEventListener('toggle', scheduleSynchronization, true);
    document.addEventListener('on:cart-drawer:before-open', scheduleSynchronization);
    document.addEventListener('on:cart-drawer:after-open', scheduleSynchronization);
    document.addEventListener('on:cart-drawer:before-close', scheduleSynchronization);
    document.addEventListener('on:cart-drawer:after-close', scheduleSynchronization);
    document.addEventListener('on:quickbuy:before-open', scheduleSynchronization);
    document.addEventListener('on:quickbuy:after-open', scheduleSynchronization);
    document.addEventListener('on:quickbuy:before-close', scheduleSynchronization);
    document.addEventListener('on:quickbuy:after-close', scheduleSynchronization);
    window.addEventListener('klaviyoForms', function (event) {
      if (!event.detail) return;
      if (event.detail.type === 'open') klaviyoPopupEventOpen = true;
      if (event.detail.type === 'close') klaviyoPopupEventOpen = false;
      scheduleSynchronization();
    });
    window.addEventListener('gorgias-widget-loaded', scheduleSynchronization);
    document.addEventListener('shopify:section:load', scheduleSynchronization);
    window.addEventListener('pageshow', scheduleSynchronization);
    if (mobileOverlayQuery.addEventListener) {
      mobileOverlayQuery.addEventListener('change', scheduleSynchronization);
    } else if (mobileOverlayQuery.addListener) {
      mobileOverlayQuery.addListener(scheduleSynchronization);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOverlayLayering, { once: true });
  } else {
    initializeOverlayLayering();
  }
})();
